export default Object.freeze({
  REGISTRADO: 1,
  SOLICITADO: 2,
  RECHAZADO: 3,
});
